import { Container } from 'react-bootstrap';
import React from 'react';
import { Utils } from '../../common/Utils';
import { InstructionStepItem } from '../common/InstructionStepItem';

const SetupInstructions: React.FC = () => {
    return (
        <Container className="main-container mt-4">


            <h2 className="mb-4">Site Setup Instructions</h2>
            <p>Please follow the following instructions to setup your site.</p>
            <br />
            <InstructionStepItem
                number={1}
                title="Manage your Site's Settings"
                description={
                    <>
                        <p>Navigate to the <a href={Utils.GetUrl('/admin/settings')}>Settings</a> page to customize your site. The settings page allows you to adjust your site's styles and configure its behavior.</p>
                    </>
                }
            />
            <InstructionStepItem
                number={2}
                title="Setup your payment providers"
                description={
                    <>
                        <p>Our site supports the following payment providers: <strong>None, SnapScan, Yoco,</strong> and <strong>Zapper</strong>. Each provider requires setup before it can be activated. Please click on the <a href={Utils.GetUrl("/admin/paymentproviders")}>Payment Options</a> page to set up. Once setup, navigate to the <a href={Utils.GetUrl('/admin/settings')}>Settings</a> page to activate.</p>
                    </>
                }
            />
            {/* <InstructionStepItem
                number={3}
                title="Link your WhatsApp number to send out order notifications"
                description={
                    <>
                        <p>The site sends notifications to customers using <strong>WhatsApp</strong> or <strong>SMS</strong>. By default, and for lower-tier packages, notifications are sent from OrderQ. If you're on an upper-tier package, you can customize your number to send messages from your own WhatsApp Business account. This improves your customers' experience by opening up a channel for future communication.</p>
                        <p>To link your WhatsApp number, navigate to the <a href={Utils.GetUrl('/admin/setupwhatsapp')}>Setup Whatsapp</a> page.</p>
                    </>
                }
            /> */}
            <InstructionStepItem
                number={3}
                title="Add categories for your products/items"
                description={
                    <>
                        <p>Configure your categories to help users with filtering. To setup, navigate to the <a href={Utils.GetUrl('/admin/categories')}>Category List</a> page and click on the <strong>Add Category</strong> button.</p>
                    </>
                }
            />
            <InstructionStepItem
                number={4}
                title="Add your products/items"
                description={
                    <>
                        <p>To complete your site, you must create all your products or items and link them to the relevant categories.</p><p>Each product or item can include a list of attributes with custom pricing (e.g., Milk Type: Full Cream, Almond, etc.).
                            Uploading an image for each product or item is also recommended to enhance the customer experience.
                        </p><p>To create a product, navigate to the <a href={Utils.GetUrl('/admin/products')}>Product List</a> page and click the <strong>Add Product</strong> button.
                        </p>
                    </>
                }
            />
            <InstructionStepItem
                number={5}
                title="Create QR codes to allow customers to easily order"
                description={
                    <>
                        <p><strong>OrderQ</strong> allows you to print one or multiple QR codes, each configured with a different delivery location. This enables you to print tags that can be placed on your counter for customers to scan, or distributed throughout your office or hospital—allowing users to scan and place orders directly to their location.</p>
                        <p>For multiple locations, the application lets you either upload a custom list or define a prefix and automatically generate location tags up to your desired maximum (e.g., Desk-1, Desk-2, ..., Desk-10).</p>
                        <p>To create navigate to the <a href={Utils.GetUrl('/admin/labelgenerator')}>Delivery Location Generator</a> page.</p>
                    </>
                }
            />
            <InstructionStepItem
                number={6}
                title="Setup a separate device for your store to manage orders"
                description={
                    <>
                        <p><strong>🎉 Your customer site is now live, you are ready to start receiving orders!</strong></p>
                        <p>We recommend purchasing a separate, affordable tablet with a mount or stand. This setup allows you to position the device in front of your store operator, making it easy to manage incoming orders.</p>
                        <p>The store operator can access the order screen by logging into the <strong>Manage Order Site</strong> using your admin email and password, or with new login credentials created on the <a href={Utils.GetUrl('/admin/storeoperator')}>Register Store Operator</a> page.</p>
                        <p>The <strong>Manage Order Site</strong> is available here: <a target='_blank' rel='noreferrer' href={`https://store.orderq.co.za/${Utils.GetAlias()}`}>{`https://store.orderq.co.za/${Utils.GetAlias()}`}</a></p>
                    </>
                }
            />
            <InstructionStepItem
                number={7}
                title="Send us feedback to help us improve our site/offerings"
                description={
                    <>
                        <p>We would love to hear from you! Please share your constructive feedback to help us improve.</p>
                        <p>Let us know what you love about the site, what frustrates you, and what features you wish we had.</p>
                        <p>We are so passionate about making this better, your next OrderQ might even be on the house!</p>
                        <p>Browse to the <a href={Utils.GetUrl('/feedback')}>Submit Feedback</a> page to complete.</p>
                    </>
                }
            />
            <InstructionStepItem
                number={8}
                title="Leave the ordering to us and do what you do best. 😎"
                description={
                    <></>
                }
            />
        </Container>
    );
};

export default SetupInstructions;